module.exports = __webpack_public_path__ + "static/second-step-apartados-bbdc6bb967bcb1c34e0683d79285acaa.svg";